import SendRequest from './SendRequest.jsx';

export {
  SendRequest
}


// WEBPACK FOOTER //
// ./components/partials/product/send-request/index.js